// Auto-generated version file - do not edit manually
// Updated by pre-commit hook

export const APP_VERSION = '1.0.0';
export const BUILD_NUMBER = 5;
export const BUILD_DATE = '2026-03-29';

export const getVersionString = () => `v${APP_VERSION} (${BUILD_NUMBER})`;
